import type { PermissionKey } from './model';

export interface PermissionDefinition {
  readonly key: PermissionKey;
  readonly label: string;
  readonly description: string;
}

export const PERMISSION_DEFINITIONS: readonly PermissionDefinition[] = [
  {
    key: 'member_approval',
    label: '成员审批',
    description: '允许处理成员加入申请'
  },
  {
    key: 'schedule_manage',
    label: '日程管理',
    description: '允许创建、编辑、删除日程和调整日程考勤设置'
  },
  {
    key: 'assignment_publish_manage',
    label: '作业发布管理',
    description: '允许发布作业并维护自己发布的作业配置'
  }
] as const;

export const SUPPORTED_PERMISSION_KEYS: readonly PermissionKey[] = PERMISSION_DEFINITIONS.map(
  (definition) => definition.key
);

export function formatPermissionKeyLabel(permissionKey: PermissionKey): string {
  return findPermissionDefinition(permissionKey).label;
}

export function formatPermissionKeyLabels(permissionKeys: readonly PermissionKey[]): string {
  if (permissionKeys.length === 0) {
    return '无权限项';
  }

  return permissionKeys.map(formatPermissionKeyLabel).join('、');
}

function findPermissionDefinition(permissionKey: PermissionKey): PermissionDefinition {
  const definition = PERMISSION_DEFINITIONS.find((candidate) => candidate.key === permissionKey);

  if (!definition) {
    throw new Error(`Unsupported permission key: ${permissionKey}`);
  }

  return definition;
}
